__turbopack_context__.v({
  "closeButton": "NHrKhW_closeButton",
  "modalContainer": "NHrKhW_modalContainer",
  "modalFooter": "NHrKhW_modalFooter",
  "modalHeader": "NHrKhW_modalHeader",
  "modalScrollArea": "NHrKhW_modalScrollArea",
  "modalTitle": "NHrKhW_modalTitle",
});
